<app-page-content *ngIf="fullPage" [showBreadcrumb]="false" class="madar--v2 ">
  <app-icon icon name="manage" class="text-primary-light mr-1"></app-icon>
  <ng-container title>
    {{ ((rolesConstants.CUSTOMER_EDIT | userRoleChecker) ? 'Receivers.ManageReceivers' : 'BreadCrumb.Receivers') | translate }}
  </ng-container>

  <div class="btns flex row" trailing *ngIf="fullPage">
    <app-export-button (buttonClicked)="onExportClicked()"></app-export-button>
    <app-actions-button></app-actions-button>
  </div>

  <ng-container *ngTemplateOutlet="list" content></ng-container>
</app-page-content>

<ng-container *ngIf="!fullPage">
  <ng-container *ngTemplateOutlet="list"></ng-container>
</ng-container>
<ng-template #list>
  <div class="list-content">
    <section class="receivers-list-wrapper">
      <div class="text-center bg-100" style="border: solid 1px #d3def4; border-radius: 8px">
        <h6 class="text-primary py-4">
          <img class="mx-1" src="assets/images/info-icon.svg" />
          {{'Customers.DeprecatedReciversLabel'|translate}}
        </h6>
      </div>
      <app-state-section
      [totalCount]="totalRowsCount"
      [state]="sectionState"
      [pageIndex]="(filters.params.offset + 1)"
      [pageSize]="filters.params.limit"
      (pageIndexChange)="onPageIndexChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      [emptyStateMainLabel]="'Customers.Receivers.emptyStateMainLabel' | translate"
      [emptyStateSubLabel]="'Customers.Receivers.emptyStateSubLabel' | translate"
      [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
      >
        <div class="table" [hidden]="!originalReceivers.length">
          <table mat-table [dataSource]="dataSource" matSort  class="table scrollable scrollable--x">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 18%">{{ "Customers.Table.CompanyName" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <ng-container matColumnDef="contactName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 18%">{{ "Customers.Table.ContactName" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.contactPerson[0]?.fullName() || '_________'}}</td>
            </ng-container>

            <ng-container matColumnDef="mobileNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 18%">{{ "Customers.Table.MobileNumber" | translate }}</th>
              <td mat-cell *matCellDef="let element" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">
                {{ element.contactPerson[0]?.mobileNumber || '_________'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 22%">{{ "Customers.Table.Locations" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <div class="location-limited-text">{{ element.locations[0]?.address }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th class="center" mat-header-cell *matHeaderCellDef style="width: 9%">{{ "Customers.Table.Actions" | translate }}</th>

              <td class="center action" mat-cell *matCellDef="let element" app-click-stop-propagation>
                <div class="flex justify-center align-center" *grantAccess="rolesConstants.CUSTOMER_EDIT" [matMenuTriggerFor]="menu">
                  <div class="flex justify-center">
                    <app-icon name="menu-vert"  class="cursor-pointer text-700"></app-icon>
                  </div>

                  <mat-menu class="item-actions" #menu>
                    <mat-option (click)="navigateToDetailsPage(element.id)">
                      <span>{{ "Buttons.Details" | translate }}</span>
                    </mat-option>

                    <mat-option *ngIf="false">
                      <span class="delete-action">{{ "Buttons.Delete" | translate }}</span>
                    </mat-option>
                  </mat-menu>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="navigateToDetailsPage(row.id)"></tr>
          </table>
        </div>

      </app-state-section>
    </section>
  </div>
</ng-template>
